import * as React from "react";
import classNames from "classnames";
import Select from "react-select";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import CancelIcon from "@material-ui/icons/Cancel";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import { Error as ErrorIcon } from "@material-ui/icons";

const ITEM_HEIGHT = 28;
var small: any = false;
let exportDialog: any = false;

const styles: any = (theme) => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: "flex",
    padding: 0,
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    // justifyContent: 'center',
    overflow: "hidden",
    paddingBottom: 1,
    maxHeight: 80,
    overflowY: "scroll",
  },
  valueContainerSmall: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    paddingBottom: 1,
    height: 40,
    maxHeight: 40,
    overflowY: "scroll",
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    margin: "0 auto",
    left: 2,
    fontSize: "0.8rem",
    // color: 'rgba(0, 0, 0, 0.39)',
    paddingBottom: 2,
    marginLeft: "0%",
    textTransform: "uppercase",
    // fontSize: '1rem',
    fontWeight: "400 !important",
    fontFamily: "Roboto",
    lineHeight: "1.1876em",
    // letterSpacing: '0.00938em',
    color: "#212121 !important",
    letterSpacing: "2px",
  },
  paper: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "#fff",
    overflow: "hidden",
    maxHeight: "150px",
    minHeight: "40px",
    left: 0,
    right: 0,
    "& > div": {
      height: "100%",
    },
  },
  menu: {
    backgroundColor: theme.palette.background,
  },
  Typography: {
    fontWeight: "500",
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      SelectProps={{
        MenuProps: {
          MenuListProps: { className: props.selectProps.classes.menu },
        },
      }}
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        backgroundColor: props.isFocused ? "#999999" : null,
        color: "#000 !important",
        // height: "15px",
        // margin: "0px",
        // padding: "4px 25px",
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <div
      className={
        small
          ? props.selectProps.classes.valueContainerSmall
          : props.selectProps.classes.valueContainer
      }
    >
      {props.children}
    </div>
  );
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={
        <>
          {props.data.color && (
            <div style={{ paddingRight: "3px", height: 20, float: "left" }}>
              <ErrorIcon style={{ color: "#FB4436", fontSize: "20px" }} />
            </div>
          )}
          {props.children}
        </>
      }
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      style={{ backgroundColor: props.data.color }}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  let positionMenu;
  if (
    props.selectProps.boxLine >= 3 &&
    props.selectProps.boxType == "budgetColumn"
  ) {
    positionMenu = { bottom: 37 };
  } else if (
    props.selectProps.boxLine >= 1 &&
    props.selectProps.boxType == "customBudget"
  ) {
    positionMenu = { bottom: 37 };
  } else if (exportDialog) {
    positionMenu = { top: 47 };
  } else {
    positionMenu = { top: 37 };
  }
  return (
    <Paper
      id="paper"
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
      style={positionMenu}
    >
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

type IProps = {
  classes: any;
  theme: any;
  placeholder: string;
  value: any;
  handleChange: any;
  listValues: any;
  categoryErrors?: any;
  modelErrors?: any;
  isMulti?: boolean;
  small?: boolean;
  boxLine?: number;
  boxType?: string;
  isClearable?: boolean;
  exportDialog?: boolean;
};

class ReactSelect2 extends React.Component<IProps> {
  state = {
    listValues: [],
  };

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(data) {
    if (
      data.listValues != undefined &&
      data.listValues.length != this.state.listValues.length
    ) {
      let listValues = data.listValues.map((lst, index) => {
        return { label: lst, value: index };
      });
      this.setState({
        listValues,
      });
    }
  }

  componentDidMount() {
    small = this.props.small;
    exportDialog = this.props.exportDialog;
    this.load(this.props);
  }

  render() {
    const {
      classes,
      theme,
      placeholder,
      value,
      handleChange,
      isMulti = false,
      boxLine,
      boxType,
      isClearable = true,
    } = this.props;
    const selectStyles = {
      fontSize: 30,
      input: (base) => ({
        ...base,
        color: theme.palette.text.primary,
        "& input": {
          font: "inherit",
        },
      }),
      control: (base) => ({
        ...base,
        height: ITEM_HEIGHT,
        "min-height": ITEM_HEIGHT,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 100000,
        backgroundColor: theme.palette.background,
      }),
    };

    return (
      <Select
        classes={classes}
        styles={selectStyles}
        textFieldProps={{
          InputLabelProps: {
            shrink: false,
          },
        }}
        closeMenuOnSelect={!isMulti}
        options={this.state.listValues}
        components={components}
        value={value}
        onChange={(e) => handleChange(e)}
        placeholder={placeholder}
        isMulti={isMulti}
        noOptionsMessage={() => ""}
        maxMenuHeight={150}
        isClearable={isClearable}
        boxLine={boxLine}
        boxType={boxType}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(ReactSelect2);



// WEBPACK FOOTER //
// ./src/common/components/ReactSelect2.tsx